<section class="w-[calc(100%-80px)] fixed top-20 left-20 z-20 flex flex-col cursor-default" [ngClass]="{'h-full': (alterations()?.length ?? 0) === 0 && !newAlteration()}">
  <div class="flex gap-4 items-center primary-green-2-background px-5 py-3">
    <div class="flex gap-4 items-center w-full">
      <div class="flex items-center cursor-pointer" (click)="goBack()">
        <img [src]="images.arrowLeft" alt="back" class="h-6 w-6" />
      </div>
      @if ((alterations()?.length ?? 0) > 0) {
        <div class="w-full flex flex-row justify-between gap-6 items-center">
          <div class="flex gap-6">
            <select2 class="setup-header-select min-h-8!" [data]="alterationsData" [value]="selectedAlteration" [templates]="{option : option}" (update)="changeAlteration($event)">
              <ng-template #option let-label="label" let-img="img" let-alt="alt">
                <div class="flex items-center pr-2 max-w-75">
                  <img [src]="img" [alt]="alt" class="h-6 w-6 mr-4 shrink-0" />
                  <app-select2-option class="flex-1" [label]="label" />
                </div>
              </ng-template>
            </select2>
            <div class="divider divider-horizontal m-0 neutrals-grey-02-background h-8!"></div>
            <div class="flex gap-2 items-center">
              <img [src]="images.alterations.calendar" class="purple-icon w-6 h-6" alt="calendar" />
              <span class="font-semibold">{{ literalService.get('alterations.data.startDate', true) }}</span>
              <span> {{ selectedAlteration?.startDateTime | date:'dd/MM/yyyy HH:mm' }} </span>
            </div>
            <div class="divider divider-horizontal m-0 neutrals-grey-02-background h-8!"></div>
            <div class="flex gap-2 items-center">
              <img [src]="images.alterations.calendar" class="purple-icon w-6 h-6" alt="calendar" />
              <span class="font-semibold">{{ literalService.get('alterations.data.endDate', true) }}</span>
              <span> {{ selectedAlteration?.endDateTime | date:'dd/MM/yyyy HH:mm' }} </span>
            </div>
          </div>
        </div>
        <div class="flex flex-row gap-2">
          <button class="flex items-center justify-center w-9 h-9 rounded-full border primary-purple-border cursor-pointer" (click)="onClickAlterationDetail()" [tooltip]="literalService.get('alterations.viewDetail', true)" [position]="TooltipPosition.BELOW">
              <img [src]="images.viewDetail" alt="view" class="h-5 w-5" />
          </button>
          <button class="flex items-center justify-center w-9 h-9 rounded-full border primary-purple-border cursor-pointer" (click)="duplicateAlteration()" [tooltip]="literalService.get('alterations.duplicate.title', true)" [position]="TooltipPosition.BELOW">
              <img [src]="images.alterations.duplicate" alt="duplicate" class="h-5 w-5" />
          </button>
        </div>
      }
    </div>
    <div class="divider divider-horizontal m-0 neutrals-grey-02-background h-8!"></div>
    <div class="shrink-0">
      <button class="flex items-center gap-1.5 px-3 py-2 rounded-full border primary-purple-border cursor-pointer w-fit" (click)="onNewAlteration.emit()">
        <img [src]="images.alterations.alteration" alt="newAlteration" class="h-5 w-5" />
        <span class="text-sm font-medium whitespace-nowrap">{{ literalService.get("alterations.new", true) }}</span>
      </button>
    </div>
  </div>
  @if ((alterations()?.length ?? 0) === 0 && !newAlteration()) {
    <section class="neutrals-white-background flex-1 flex flex-col justify-center items-center gap-6">
      <img [src]="images.alterations.emptyState" class="w-60 h-60" alt="alterationEmptyState" />
      <div class="flex flex-col gap-5 justify-center items-center">
        <span class="font-bold text-3xl neutrals-grey-04-text">{{ literalService.get('alterations.emptyState.title', true) }}</span>
        <button class="flex items-center gap-1.5 px-8 py-4 rounded-full primary-purple-background neutrals-white-text uppercase cursor-pointer w-fit" (click)="onNewAlteration.emit()">
          {{ literalService.get("alterations.emptyState.create", true) }}
        </button>
      </div>
    </section>
  }
</section>
